<template>
  <div class="link-container">
    <div class="header-nav-search" ref="searchWrap">
      <i class="el-input__icon el-icon-search" @click="searchEmit"></i>
    </div>
    <el-divider direction="vertical"></el-divider>
    <div class="header-link">
      <a href="https://www.shisu.edu.cn" target="_blank">上外主页</a>
    </div>
    <el-divider direction="vertical"></el-divider>
    <div class="header-link">
      <a href="http://global.shisu.edu.cn" target="_blank">SISU Global</a>
    </div>
    <el-divider direction="vertical"></el-divider>
    <div class="header-link">
      <a href="http://www.saggas.shisu.edu.cn/" target="_blank">SAGGAS</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {

  },
  components: {

  },
  mounted() {

  },
  methods: {
    // 检索数据传递
    searchEmit() {
      this.$router.push({
        path: "/views/search",
        [this.searchInfo ? 'query' : '']: {
          search: this.searchInfo
        }
      })
    },
  },
}
</script>

<style lang="less">
.link-container {
  display: flex;
  align-items: center;
  .header-link {
    font-size: 16px;
    line-height: 1;
    a {
      color: #fff;
    }
  }
  .header-nav-search {
    display: flex;
    align-items: center;
    .el-icon-search {
      color: #fff;
      cursor: pointer;
    }
    i.close-search {
      color: #fff;
      margin-left: 8px;
      cursor: pointer;
    }
  }
  .header-search {
    width: 36px;
    height: 36px;
    transition: all 0.3s ease-in;
    display: flex;
    align-items: center;
    overflow: hidden;
    border-radius: 36px;
    border: 1px solid transparent;
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #fff;
      border: none;
    }
    /deep/ .el-input__prefix,
    /deep/ .el-input__suffix {
      color: #fff;
      cursor: pointer;
    }
    &.search-active {
      width: 300px;
      background-color: rgba(255, 255, 255, 0.7);
      border: 1px solid rgba(255, 255, 255, 0.6);
      z-index: 200;
      /deep/ .el-input__inner {
        color: #797979;
      }
      /deep/ .el-input__prefix,
      /deep/ .el-input__suffix {
        cursor: pointer;
        .el-icon-search {
          color: #797979 !important;
        }
      }
    }
  }
}
</style>